import { MouseEvent, useRef } from "react";

const useDoubleClick = ({
  doubleClickDelay,
  onClick,
  onDoubleClick
}: {
  doubleClickDelay: number;
  onClick: () => unknown;
  onDoubleClick?: () => unknown;
}) => {
  const timerRef = useRef<number | null>();

  return (event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();

    if (!timerRef.current) {
      timerRef.current = setTimeout(() => {
        onClick();
        timerRef.current = null;
      }, doubleClickDelay) as unknown as number;
    } else {
      onDoubleClick?.();
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };
};

export default useDoubleClick;
